import Vue from "vue";
import Vuex from "vuex";
import router from '@/router'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    excludeCache:[],
    tabList:[],
    moveFlash:[],
    menus: [],
    movemenu:[],
    flag:false,
    userMenus:null, // 用户路由菜单
    flag1:true,  //当请求出错时，提示只显示一次
    flag404:false, //处理404页面
  },
  getters: {
    getExcludeCache(state){
      return state.excludeCache;
    },
    // 获取tbsList
    getTabs: (state) => {
      return state.tabList
    },
    getMenus: (state) => {
      return state.menus
    },
    getMoveMenu: (state) => {
      return state.movemenu
    },
    getUserMenus(state) {
      return state.userMenus;
  }
  },
  mutations: {
    changeFlag404:(state,flag)=>{
      state.flag404=flag;
    },
    changeFlagToF:(state)=>{
      state.flag1=false;
    },
    changeFlagToT:(state)=>{
      state.flag1=true;
    },
    addExcludeCache: (state,menu) => {
      state.excludeCache.push(menu)
      // 下一个更新清空排除的tag
      Vue.nextTick(()=>{
        state.excludeCache.length = 0;         
      });
    },
    updateMenus:(state,menus)=>{
      state.menus=[...menus]
    },
    addTab: (state, tab) => {
      // 如果tab已经存在，不添加新的tabs
      if (state.tabList.some(item => item.path === tab.path)) return
      state.tabList.push(tab)
    },
    addMenu: (state, menu) => {
      let flag;
      for(let i=0;i<state.movemenu.length;i++){
        if(menu.linkUrl==state.movemenu[i].linkUrl){
          flag=true
          break
        }else{
          flag=false
        }
      }
      if(!flag){
        state.movemenu.push(menu)
      }
      
    },
    delflash: (state, menu) => {
      for(let j=0;j<state.moveFlash.length;j++){
        if(menu==state.moveFlash[j].name){
          state.moveFlash.splice(j,1)
          j--
          break
        }
      }
    },
    isflash: (state, menu) => {
      // debugger
      for(let i=0;i<state.moveFlash.length;i++){
        if(menu.title==state.moveFlash[i].title){
          state.moveFlash[i]=menu
          state.flag=true
          break
        }else{
          state.flag=false
        }
      }
      if(!state.flag){
        state.moveFlash.push(menu)
        // state.flag=true
      }
    },
    deleteMenu: (state,menu) => {
      let index = state.movemenu.indexOf(menu)
      
      if (index !== -1) {
        state.movemenu.splice(index,1)

        // 关闭掉的不是自己
        if (router.currentRoute.path !== menu.linkUrl)return;

        // 添加排除名单
        state.excludeCache.push(menu.cssName);
        // 下一个更新清空排除的tag
        Vue.nextTick(()=>{
          state.excludeCache.length = 0;         
        });
        // 立刻销毁组件
        // history.back();

    }
    },
    clearMenu:(state) => {
      state.movemenu=[]
    },
    allMenu: (state,menu) => {
      state.movemenu=[...menu]
    },
    changeUserMenus(state,payload) {
      state.userMenus = payload;
  }
  },
  actions: {},
  modules: {},
});